import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
// Send the HttpOnly auth cookie with every API request (must load before App).
import './services/httpCredentials';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { redirectToCanonicalHost } from './services/canonicalHost';

// Before anything renders or asks the API who we are: the app has one
// address, because the session cookie is only first-party on that one.
redirectToCanonicalHost();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
